// logging.service.ts
import { Injectable } from '@angular/core';
import { Span, SpanStatusCode } from '@opentelemetry/api';

@Injectable()
export class LoggingService {
  logEvent(span: Span, message: string, data?: Record<string, any>): void {
    if (span && message) {
      span.addEvent(message, data || {});
    }
  }

  logError(span: Span | null, errorMessage: string, errorData?: any): void {
    if (span) {
      span.addEvent(errorMessage, errorData);
      span.setStatus({ code: SpanStatusCode.ERROR, message: errorMessage });
    }
  }
}
